<vo-vm-theme-provider>
  <div class="app">
    <vm-header [vmRemoveFromView]="true"/>
    <vm-sidenav *ngIf="navigations" [data]="navigations" />
    <main class="main">
      <router-outlet></router-outlet>
    </main>
    <vm-footer *ngIf="footer" [footer]="footer" [vmRemoveFromView]="true"></vm-footer>
  </div>
</vo-vm-theme-provider>
